import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  select(event) {
    this.element.querySelectorAll(".is-active").forEach((el) => el.classList.remove("is-active"))
    event.currentTarget.classList.add("is-active")
  }
}